import React from 'react';
import { Code } from 'react-content-loader';
class Placeholder extends React.Component {
  render() {
    return (
      <div className='hc-item hc-placeholder card ux-card px-3 pt-4'>
        <Code height={ '105' } width={ '285' }/>
      </div>);
  }
}

export default Placeholder;
